module.exports = __webpack_public_path__ + "static/media/iconSetting.c140f024.svg";